





















import { Component, Vue, Watch } from "@/common";

@Component({})
export default class Breadcrumb extends Vue {
  levelList: any[] = [] as any;

  created() {
    this.getBreadcrumb();
  }

  @Watch("$route")
  watchRoute() {
    this.getBreadcrumb();
  }

  getBreadcrumb() {
    let matched: any[] = this.$route.matched.filter(item => item.path!=="/Home");
    const first = matched[0];
    matched = [{ path: "/Home", meta: { title: this.$t("navbar.Home") } }].concat(matched);
    this.levelList = matched;
  }
}
